import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment/moment';

@Pipe({
  name: 'gsbDateTimePipe'
})
export class GsbDateTimePipe implements PipeTransform {
  transform(date: Date): string {
    return moment(date).format('DD/MM/YYYY HH:mm');
  }
}
